import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import VistaInstanciaParametro from './VistaInstanciaParametro';

//Importación de actions.
import * as actions from '../actions/Actions';


const mapStateToProps = (state) => {
    return {
        data: state.vistaInstanciaParametro,
        atlas: state.atlas
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      actions: bindActionCreators({...actions}, dispatch)
    }
  }
  

const VistaInstanciaParametroContainer = connect(mapStateToProps, mapDispatchToProps)(VistaInstanciaParametro);

export default VistaInstanciaParametroContainer;
